import { makeStyles } from '@mui/styles';

const style = makeStyles((theme?: any) => ({
  segment: {
    marginTop: theme.spacing(16),
    marginBottom: theme.spacing(8),
  },
  content: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },

  imgBox: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  mainHeading: {
    paddingBottom: theme.spacing(7),
  },
  card: {
    '& > div': {
      height: 'auto',
    },
    // padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export default style;
